export default __webpack_public_path__ + "static/media/bttn-google-play.2b526fba.svg";